import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBgpSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M50 91.666c23.012 0 41.667-18.654 41.667-41.666C91.667 26.988 73.012 8.333 50 8.333S8.333 26.988 8.333 50C8.333 73.01 26.988 91.666 50 91.666Z",
		stroke: "green",
		strokeWidth: 3
	}), /* @__PURE__ */ _jsx("path", {
		d: "m25.394 57.773 19.5 12.313L71.681 27",
		stroke: "green",
		strokeWidth: 3,
		strokeLinecap: "round"
	})]
});
export default SvgBgpSuccess;
